// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateFnsFormatInfoDialog_wrapper__HyOJb","table":"DateFnsFormatInfoDialog_table__1eVLx"};